export const selectEquipmentTestStatus = {
    bindings: {
        module: '@',
        identifier: '@',
        label: '@'
    },
    template: require('./select-equipment-test-status.html'),
    controller: 'SelectEquipmentTestStatusController'
};
